module.exports = __webpack_public_path__ + "static/media/fight.75144610.jpg";